import { ICON_SIZE } from '@components/v2/constants';
import { ListItemAvatarProps, ListItemAvatar as MuiListItemAvatar } from '@mui/material';
import React from 'react';

type Props = Pick<ListItemAvatarProps, 'children' | 'className'> & {
  size?: number;
};

const ListItemAvatar = ({ children, className, size = ICON_SIZE.lg }: Props) => {
  const child = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<{ size?: number }>, { size })
    : children;

  return <MuiListItemAvatar className={className}>{child}</MuiListItemAvatar>;
};

export default ListItemAvatar;
